// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"8a4ee494","485":"f6ebe5d2"}[chunkId] + ".chunk.css";
};